import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import ColumnPage from '../../../components/Column/pages/List';
import { ModulePermissionProps } from '../../../../../common/module/types';

const SystemConfig =  {
  filterName: 'component.filterTitle.promotion-material-column',
  blockName: 'component.formTitle.promotion-material-column',
  blockType: 'promotionMaterialColumn',
  moduleType: 'Promotion',
  addSuccessText: 'global.submit.success'
}

const PromotionPruforceColumnPage: FC<RouteComponentProps & ModulePermissionProps> = (props) => {
  return (
    <ColumnPage { ...props } { ...SystemConfig }  />
  )
};

export default PromotionPruforceColumnPage;
